import React from "react";
const IconPao = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" {...props}>
    <path
      d="M42 31.667c0 1.472-6.044 2.666-13.5 2.666S15 33.14 15 31.667m27 0C42 30.194 35.956 29 28.5 29S15 30.194 15 31.667m27 0v14.666C42 47.806 35.956 49 28.5 49S15 47.806 15 46.333V31.667M33.674 8.407c.494.777-4.205 4.651-10.495 8.654-6.29 4.003-11.79 6.618-12.284 5.841M33.674 8.407c-.494-.777-5.994 1.839-12.284 5.841-6.29 4.003-10.99 7.878-10.495 8.654M33.674 8.407l2.237 3.515c.494.777-4.205 4.651-10.495 8.654-6.29 4.003-11.79 6.618-12.284 5.841l-2.237-3.515"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
export default IconPao;
